export const LineSpectrogramFFTSize = 4096;
